<template>
    <GlobalWindow
        :title="title"
        :visible.sync="visible"
        :confirm-working="isWorking"
        @confirm="confirm"
    >
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入名称" v-trim/>
            </el-form-item>
            <el-form-item label="公司编码" prop="code">
                <el-input v-model="form.code" placeholder="请输入公司编码" v-trim/>
            </el-form-item>
            <el-form-item label="公司类型" prop="type">
                <el-select v-model="form.type" placeholder="请选择">
                    <el-option label="劳务公司" :value="0"></el-option>
                    <el-option label="内部组织" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="linkName">
                <el-input v-model="form.linkName" placeholder="请输入联系人" v-trim/>
            </el-form-item>
            <el-form-item label="手机号" prop="linkPhone">
                <el-input type="number" v-model="form.linkPhone" maxlength="11" placeholder="请输入手机号" v-trim/>
            </el-form-item>
        </el-form>
    </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaCompanyWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        type: '',
        code: '',
        linkName: '',
        linkPhone: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/company',
      'field.id': 'id'
    })
  }
}
</script>
